import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { IFeaturedVideoProps } from "./featured-video";

export const FeaturedVideoBase = styled.div`
  padding: 0 ${theme.spacing[4]};

  iframe {
    border-radius: 5px;
  }
`;

export const CopyWrapper = styled.div``;

export const Title = styled.h2``;

export const Description = styled.div`
  font-size: ${theme.fontSizes[2]};
  line-height: ${theme.leading.normal};
  margin-bottom: 1rem;
`;
